export default "__VITE_ASSET__2e958822__"